"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
* Global components
* By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
* Summary
* This component renders a SVB table
*/

/**
* SVBTables
* @param {Object[]} [data = [{}]] - Data to be rendered on the table
* @param {boolean} [renderHeaders = true] - Boolean that determines if headers will be rendered or not
* @param {number[]} [widths = []] - Widths of the columns on bootstrap numbers (1 to 12)
* @param {string} [extraClasses = ''] - Extra classes to be added to the table tag
* @returns JSX element
*/

const SVBTables = props => {
  var _props$widths;
  const data = props.data || [{}];
  const renderHeaders = props.renderHeaders || false;
  const widths = ((_props$widths = props.widths) === null || _props$widths === void 0 ? void 0 : _props$widths.map(value => "col-".concat(value))) || Object.entries(data[0]).map(_ => '');
  const extraClasses = props.extraClasses || '';
  const renderContent = (data, renderHeaders, widths) => {
    const renderArray = [];
    const bodyArray = [];
    data.forEach((element, rowIndex) => {
      if (renderHeaders && rowIndex === 0) {
        const headersArray = [];
        let headerIndex = 0;
        for (const header in element) {
          headersArray.push( /*#__PURE__*/_react.default.createElement("th", {
            key: "header-col".concat(headerIndex),
            className: widths[headerIndex]
          }, header));
          headerIndex++;
        }
        renderArray.push( /*#__PURE__*/_react.default.createElement("thead", {
          key: "table-head"
        }, /*#__PURE__*/_react.default.createElement("tr", {
          key: "header-row"
        }, headersArray)));
      }
      const rowArray = [];
      let colIndex = 0;
      for (const elementKey in element) {
        rowArray.push( /*#__PURE__*/_react.default.createElement("td", {
          key: "data-row".concat(rowIndex, "-col").concat(colIndex),
          className: widths[colIndex]
        }, element[elementKey]));
        colIndex++;
      }
      bodyArray.push( /*#__PURE__*/_react.default.createElement("tr", {
        key: "data-row".concat(rowIndex)
      }, rowArray));
    });
    renderArray.push( /*#__PURE__*/_react.default.createElement("tbody", {
      key: "table-body"
    }, bodyArray));
    return renderArray;
  };
  return /*#__PURE__*/_react.default.createElement("table", {
    className: "svb-table ".concat(extraClasses)
  }, renderContent(data, renderHeaders, widths));
};
var _default = SVBTables;
exports.default = _default;